import React, { FC, memo } from 'react'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { makeStyles, Typography } from 'transfix-ui/core'
import { IShipmentStop } from 'types/graphqlTypes'
import { capitalize } from 'utils/capitalize'
import { companyNameInitials } from 'utils/initials'

export interface IShipmentInfoProps {
  shipmentId: string
  shipperName: string
  stops: Pick<IShipmentStop, 'id' | 'city' | 'stateCode'>[]
}

const useShipmentInfoStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
  },
  shipmentDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 6,
  },
}))

export const ShipmentInfo: FC<IShipmentInfoProps> = memo(({ shipmentId, shipperName, stops }) => {
  const classes = useShipmentInfoStyles()
  const companyInitials = companyNameInitials(shipperName)
  const pickupStop = stops[0]
  const deliveryStop = stops[stops.length - 1]

  const pickupCity = capitalize(pickupStop?.city || '')
  const deliveryCity = capitalize(deliveryStop?.city || '')

  return (
    <div className={classes.root}>
      <Tooltip
        position='top'
        id={shipmentId}
        trigger={<Typography variant='body1'>{companyInitials}</Typography>}>
        {shipperName}
      </Tooltip>
      <a
        href={`${__ROOT__}/shipment-details/${shipmentId}`}
        target='_blank'
        rel='noopener noreferrer'>
        <Typography variant='body1'>#{shipmentId}</Typography>
      </a>
      <Typography variant='body2'>
        {pickupCity}, {pickupStop.stateCode} - {deliveryCity}, {deliveryStop.stateCode}
      </Typography>
    </div>
  )
})
